const article = {
  "article.title": "Guía del Basetao Spreadsheet: qué es y cómo usarlo",
  "article.meta.description":
    "Descubre qué es un Basetao Spreadsheet, qué encontrarás dentro y cómo usarlo para comparar productos, vendedores y categorías al pedir a través de Basetao.",
  "article.breadcrumb": "Guía del Spreadsheet",
  "article.h1": "Guía del Basetao Spreadsheet: qué es y cómo usarlo",

  "article.author": "Por:",
  "article.author.name": "Equipo editorial de Basetao Sheet",
  "article.published": "Publicado:",
  "article.updated": "Actualizado:",
  "article.date": "18 de agosto de 2026",

  "article.intro":
    "Un Basetao Spreadsheet es una lista compartida y organizada de enlaces de productos, categorías, vendedores y notas que los compradores usan para encontrar y comparar artículos pedidos a través de Basetao. En resumen, convierte un catálogo amplio y disperso en un punto de partida ordenado que puedes filtrar, ordenar y compartir. Esta guía explica qué suele contener, cómo leerlo y cómo usarlo para comprar de forma más eficiente.",

  "article.toc.title": "En esta página",
  "article.toc.1": "¿Qué es un Basetao Spreadsheet?",
  "article.toc.2": "Qué encontrarás dentro",
  "article.toc.3": "Cómo usar un Basetao Spreadsheet",
  "article.toc.4": "Por qué los compradores confían en una hoja",
  "article.toc.5": "Consejos para aprovecharlo al máximo",
  "article.toc.6": "Preguntas frecuentes",

  "article.s1.h2": "¿Qué es un Basetao Spreadsheet?",
  "article.s1.p1":
    "Basetao es un agente de compras que ayuda a los compradores fuera de China a pedir en marketplaces como Taobao, Weidian y 1688, y a enviar esos artículos internacionalmente. Un Basetao Spreadsheet es un recurso complementario: una lista que alguien ya ha creado y compartido, con enlaces a productos concretos, sus categorías, vendedores y notas útiles.",
  "article.s1.p2":
    "Piensa en él como un mapa seleccionado del catálogo, no como el catálogo en sí. En lugar de buscar en cientos de páginas, partes de un conjunto de artículos que otros compradores ya han localizado y, en muchos casos, revisado. Eso ahorra tiempo y te da una forma más enfocada de comparar tus opciones.",

  "article.s2.h2": "Qué encontrarás dentro de un Basetao Spreadsheet",
  "article.s2.p1":
    "Las hojas de cálculo varían, pero la mayoría de las bien hechas se basan en unas pocas columnas consistentes. Esto es lo que significa cada columna y por qué ayuda.",
  "article.s2.table.c1": "Columna",
  "article.s2.table.c2": "Qué muestra",
  "article.s2.table.c3": "Por qué ayuda",
  "article.s2.r1.c1": "Producto",
  "article.s2.r1.c2": "El artículo concreto y su enlace",
  "article.s2.r1.c3": "Ir directo al artículo que quieres",
  "article.s2.r2.c1": "Categoría",
  "article.s2.r2.c2": "A qué grupo pertenece el artículo",
  "article.s2.r2.c3": "Filtrar zapatos, sudaderas, bolsos y más",
  "article.s2.r3.c1": "Vendedor",
  "article.s2.r3.c2": "El nombre de la tienda o el vendedor",
  "article.s2.r3.c3": "Detectar vendedores fiables que reconozcas",
  "article.s2.r4.c1": "Notas / QC",
  "article.s2.r4.c2": "Control de calidad y otras observaciones",
  "article.s2.r4.c3": "Evitar problemas antes de pedir",

  "article.s3.h2": "Cómo usar un Basetao Spreadsheet",
  "article.s3.p1":
    "No necesitas herramientas especiales para usar una hoja de cálculo. Sigue estos cuatro pasos para pasar de una lista a un pedido seguro.",
  "article.s3.step1.title": "1. Empieza por una categoría",
  "article.s3.step1.text":
    "Filtra la hoja por la categoría que te interesa — zapatos, camisetas, chaquetas, bolsos o accesorios — para ver solo las filas relevantes.",
  "article.s3.step2.title": "2. Revisa las notas",
  "article.s3.step2.text":
    "Lee las notas de vendedores y control de calidad asociadas a un producto. Suelen destacar detalles de talla, calidad o envío.",
  "article.s3.step3.title": "3. Abre el enlace del producto",
  "article.s3.step3.text":
    "Usa el enlace del producto para ver el artículo en el sitio principal y confirmar el precio, las fotos y la disponibilidad antes de comprometerte.",
  "article.s3.step4.title": "4. Compara antes de comprar",
  "article.s3.step4.text":
    "Pon dos o tres artículos similares lado a lado para comparar vendedores y detalles, y elige el que mejor se adapte a ti.",

  "article.s4.h2": "Por qué los compradores confían en una hoja de cálculo",
  "article.s4.p1":
    "La razón principal es simple: una hoja de cálculo elimina gran parte de la fricción de navegar. En lugar de abrir página tras página y tratar de recordar lo que viste, obtienes una única vista ordenable de productos, categorías, vendedores y notas. Es especialmente útil cuando eres nuevo usando un agente de compras, porque la lista te da un punto de partida ya organizado, y las notas pueden ayudarte a evitar errores comunes como pasar por alto la talla o elegir un vendedor poco fiable.",

  "article.s5.h2": "Consejos para aprovecharlo al máximo",
  "article.s5.p1": "Ten en cuenta estos hábitos para que la hoja trabaje más por ti.",
  "article.s5.t1": "Verifica antes de pedir: los enlaces y precios pueden cambiar; confirma siempre el artículo en la página del producto.",
  "article.s5.t2": "Usa las categorías para acotar tu búsqueda en lugar de desplazarte por toda la lista.",
  "article.s5.t3": "Añade tus propias notas mientras comparas para mantener tu selección organizada.",
  "article.s5.t4": "Guarda en favoritos los artículos que te gustan para volver más tarde.",

  "article.s6.h2": "Preguntas frecuentes",
  "article.s6.q1": "¿Necesito una cuenta de Basetao para usar la hoja de cálculo?",
  "article.s6.a1":
    "No. Puedes leer y usar la hoja libremente. Solo necesitas una cuenta si decides pedir a través de un agente de compras o el sitio principal.",
  "article.s6.q2": "¿Los productos de la hoja están siempre disponibles?",
  "article.s6.a2":
    "La disponibilidad, los precios y los datos de los vendedores pueden cambiar con el tiempo. La hoja es un buen punto de partida, pero confirma siempre los detalles actuales en la página del producto.",

  "article.s7.h2": "Conclusión",
  "article.s7.p1":
    "Un Basetao Spreadsheet es una de las formas más sencillas de comprar a través de un agente de compras sin empezar de cero. Al ofrecerte una lista estructurada de productos, categorías, vendedores y notas, te ayuda a ahorrar tiempo, comparar con más facilidad y tomar decisiones más seguras. Empieza por una categoría, revisa las notas y confirma la página del producto antes de comprar.",

  "article.cta.text": "¿Listo para navegar? Explora todo el catálogo en el sitio principal.",
  "article.cta.button": "Comprar ahora",
  "article.backHome": "Volver al inicio",
};

export default article;